import httpClient from "./httpClient";
import { getApiBaseUrl } from "../data/authStorage";

const root = `${getApiBaseUrl()}/organizations/reporting`;

export async function getReporting(params) {
  const { data } = await httpClient.get(root, { params });
  return data;
}

export async function askReporting(question, params) {
  const { data } = await httpClient.post(`${root}/intelligence`, { question, ...params }, { suppressGlobalErrorToast: true });
  return data;
}
